jQuery(function ($) {
    // Hide Summary Accordion until plan is selected
    var accordionLastChild = $(
      "#mobile--accordion #accordionExample > .accordion-item:last-child"
    );
    accordionLastChild.addClass("d-none");
  
    //  RAM Block SELECTED
    var defaultPrice;
    var ramPrice;
  
    //   Finance Variable
    var minDown;
    var maxDown;
    var financePerMonth;
    var finalPlanPrice;
  
    //   Tab Credit
    var credit = $(".tab-credit-price").text();
    var tab_credit = parseFloat(credit.replace("$", "")).toFixed(2);
  
    // RAM | PLANS Functions
    ramblock();
    plans();
  
    //   Run the function to get Default Value and Calculations
    getDefaultFullPrice();
  
    //  Pay Full Price - Radio Button
    $("#amount-checked").on("click", function () {
      $(this).data("clicked", true);
      $("#emi-checked").data("clicked", false);
      $(".form-control").val(" ").prop("disabled", true);
      $(".put-price-back-block").text("?");
  
      clear();
  
      $("#mobile--accordion  .tab-content .tab-pane").each(function () {
        $("#mobile--accordion  .tab-content .tab-pane")
          .find(".sub-promotion-block")
          .removeClass("active");
      });
      // get the data attribute of active memory
      var currentDevicePrice = getDefaultFullPrice();
    });
  
    //  Finance - Radio Button
    $("#emi-checked").on("click", function () {
      $(this).data("clicked", true);
      $("#amount-checked").data("clicked", false);
      //  Get Min and Max downpayment values
      minDown = $(".min-down-val").text();
      maxDown = $(".max-down-val").text();
  
      clear();
  
      $("#mobile--accordion  .tab-content .tab-pane").each(function () {
        $("#mobile--accordion  .tab-content .tab-pane")
          .find(".sub-promotion-block")
          .removeClass("active");
      });
      // get the data attribute of active memory
      $(".form-control").prop("disabled", false).val(minDown);
  
      financePriceCalculations(minDown, maxDown);
    });
  
    // function to change RAM BLOCK
  
    function ramblock() {
      $("#device-information .memory-block p").each(function () {
        $(this).on("click", function () {
          // Select Plan Again
          // $("#mobile--accordion  .tab-content .tab-pane").each(function () {
          //   $("#mobile--accordion  .tab-content .tab-pane")
          //     .find(".sub-promotion-block")
          //     .removeClass("active");
          // });
  
          if (!$(this).hasClass("memory-active")) {
            $(this).addClass("memory-active");
            $(this).removeClass("drop-shadow");
            $(this).siblings().removeClass("memory-active");
            $(this).siblings().addClass("drop-shadow");
  
            //   Change Memory on click to the selected memories
            value_gb = $(this).text();
            $("#selected-memory-value").text(value_gb);
            $(".device-size").text(value_gb);
          }
  
          //   Change Price according to Memory Selection
          let dataram = $(this).attr("data-ram");
  
          $("[data-ramprice]").each(function (ramDevicePrice) {
            // console.log($(this).data("ramprice"));
            if ($(this).data("ramprice") == dataram) {
              $(this).removeClass("d-none");
              $(this).siblings().addClass("d-none");
  
              ramPrice = $(".payment-blocks .get-price-block").text(
                $(this).text().replace("$", "")
              );
  
              // Calculations -
              getDefaultFullPrice();
  
              // Finance
              // financePriceCalculations(minDown, maxDown);
              if ($("#emi-checked").data("clicked")) {
                financePriceCalculations(minDown, maxDown);
              }
            }
          });
        });
      });
    }
  
    // Plans Selected
    function plans() {
      $("#mobile--accordion  .tab-content .tab-pane .sub-promotion-block").each(
        function () {
          // On Click
          $(this).on("click", function () {
            accordionLastChild.removeClass("d-none");
  
            $("#mobile--accordion  .tab-content .tab-pane").each(function () {
              $("#mobile--accordion  .tab-content .tab-pane")
                .find(".sub-promotion-block")
                .not(this)
                .removeClass("active");
            });
  
            if (!$(this).hasClass("active")) {
              $(this).addClass("active");
            }
  
            // get the price
            let plan_price = $(this).find(".price-block").children()[0].innerHTML;
            let removeDollarsign = parseInt(plan_price.replace("$", ""));
            // console.log(removeDollarsign);
  
            // get the decimal value
            let plan_decimal =
              $(this).find(".decimal-block ")[0].childNodes[1].innerHTML;
            // console.log(plan_decimal);
  
            // concated Price and decimal
            finalPlanPrice = parseFloat(
              removeDollarsign + "." + plan_decimal
            ).toFixed(2);
            let planTax = parseFloat(finalPlanPrice) * 0.13;
            console.log(planTax);
            let finalPlanPriceWithTax = (
              parseFloat(finalPlanPrice) + planTax
            ).toFixed(2);
  
            if ($("#amount-checked").data("clicked")) {
              selectedPlans(finalPlanPrice);
            } else {
              let financePerMonthValue = financePriceCalculations(
                minDown,
                maxDown
              );
  
              console.log("Ram Price per month", financePerMonthValue);
  
              financeSelectedPlans(financePerMonthValue, finalPlanPrice);
            }
  
            //   Header Display
            $(".choose-plan-header-text").text(
              "$" + finalPlanPrice + " unlimited"
            );
  
            // Grab the services of plan
            let services = $(this).find(".promo-service-list-block")[0]
              .children[0].innerText;
  
            var str = nl2br(services);
            $(".service-block-header").removeClass("d-none");
            $(".service-block-header").html(str);
          });
        }
      );
  
      return finalPlanPrice;
    }
  
    //  --------------------------------------------------------------------------------------------------------
    function nl2br(services, is_xhtml) {
      var breakTag = is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "";
      return (services + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, breakTag);
    }
  
    //  All the default Calculations with changing price related to RAM
    function getDefaultFullPrice() {
      $("[data-ramprice]").each(function () {
        // console.log($(this).data("ramprice"));
        if (!$(this).hasClass("d-none")) {
          defaultPrice = parseFloat($(this).text().replace("$", "")).toFixed(2);
        }
      });
  
      // Full Price Payment
      if ($("#amount-checked").data("clicked")) {
        let defaultTaxPrice = defaultPrice * 0.13;
        let defaultPriceWithTax = parseFloat(defaultPrice) + defaultTaxPrice;
  
        // Display in Summary Accordion
        $(".tax-summary-tax").text("$" + defaultTaxPrice.toFixed(2) + " Now");
        $(".total-summary-tax").text(
          "$" + defaultPriceWithTax.toFixed(2) + " Now"
        );
  
        // Display Header
        $(".selected-payment-option").text("You are paying full price");
        $(".paid-down-payment").text("$" + defaultPrice);
      }
  
      // Finance - 29 change
      if ($("#emi-checked").data("clicked")) {
        // finalNotWorkingRamBlockClickCalculatioin(defaultPrice);
        console.log("in");
        // financePriceCalculations(minDown, maxDown); // 29 -change
        let planprice = plans(); // 29 - change
        financePriceCalculations(minDown, maxDown);
        // financeSelectedPlans(defaultPrice, planprice); //29 - change
      }
    }
  
    // Selected Plans
    function selectedPlans(selectedPlan) {
      let selectedTaxPlan = selectedPlan * 0.13;
      let selectedPlanWithTax = parseFloat(selectedPlan) + selectedTaxPlan;
  
      // Display Plan Data
      $(".tax-summary-month").text(
        "$" + selectedTaxPlan.toFixed(2) + " per month"
      );
      $(".total-summary-month").text(
        "$" + selectedPlanWithTax.toFixed(2) + " per month"
      );
    }
  
    //   Finance Calculations function
    function financePriceCalculations(minDown, maxDown) {
      let downpayment = $(".form-control").val();
      let downpaymentTax = (parseFloat(downpayment) * 0.13).toFixed(2);
  
      // console.log("Down-d", downpayment);
  
      $("[data-ramprice]").each(function () {
        // console.log($(this).data("ramprice"));
        if (!$(this).hasClass("d-none")) {
          defaultDevicePrice = parseFloat(
            $(this).text().replace("$", "")
          ).toFixed(2);
        }
      });
  
      console.log("Down-device", defaultDevicePrice);
      // FORMULA FOR MONTHLY PRICE
      financePerMonth = parseFloat(
        (defaultDevicePrice - downpayment - tab_credit) / 24
      ).toFixed(2);
  
      // ------------- Default on First Click ----------------------------------
      if ($("#emi-checked").data("clicked")) {
        let planprice = plans();
        financeSelectedPlans(financePerMonth, planprice);
      }
      // console.log("finace", financePerMonth);
      // Put per month price on same block at bottom bar
      $(".put-price-back-block").text("$" + financePerMonth);
  
      // Display - DownPayment summary
      $(".tax-summary-tax").text("$" + downpaymentTax + " Now");
      $(".total-summary-tax").text(
        "$" + (parseFloat(downpayment) + parseFloat(downpaymentTax)).toFixed(2)
      );
  
      // Header Display
      financeHeaderDetails(downpayment, financePerMonth);
  
      // ------------- Default on First Click ----------------------------------
  
      // Keyup functions
      $(".form-control").on("keyup", function () {
        downpayment = $(".form-control").val();
        financePerMonth = parseFloat(
          (defaultDevicePrice - downpayment - tab_credit) / 24
        ).toFixed(2);
  
        financeCalKeyup(
          downpayment,
          financePerMonth,
          defaultDevicePrice,
          minDown,
          maxDown
        );
  
        //   Header Display Function
        financeHeaderDetails(downpayment, financePerMonth);
  
        // Loop again
        // financePriceCalculations(minDown, maxDown);
  
        // Finance Selected Plan
        // financeSelectedPlans(financePerMonthValue, finalPlanPrice);
      });
  
      return financePerMonth;
    }
  
    //   Finance Plans Section and calculations accordingly
    function financeSelectedPlans(perMonthValue, finalPlanPrice) {
      let monthlyPlanTax = (
        (parseFloat(perMonthValue) + parseFloat(finalPlanPrice)) *
        0.13
      ).toFixed(2);
  
      let monthlyPanWithTax = (
        parseFloat(perMonthValue) +
        parseFloat(finalPlanPrice) +
        parseFloat(monthlyPlanTax)
      ).toFixed(2);
  
      //   Tax Summary Display
      $(".tax-summary-month").text("$" + monthlyPlanTax + " per month");
  
      //   Total Summary Display
      $(".total-summary-month").text("$" + monthlyPanWithTax + " per month");
  
      return monthlyPanWithTax;
    }
  
    //   Finance Cal Funtion on Keyup
    function financeCalKeyup(
      downpayment,
      financePerMonth,
      defaultDevicePrice,
      minDown,
      maxDown
    ) {
      // If down > min or down < min
      if (
        parseFloat(downpayment) < parseFloat(minDown) ||
        parseFloat(downpayment) > parseFloat(maxDown)
      ) {
        $(".put-price-back-block").addClass("d-none");
        $(".per-month-text").html(
          "Minimum Downpayment: $" +
            minDown +
            "<br/>" +
            "Maximum Downpayment: $" +
            maxDown
        );
  
        accordionLastChild.addClass("d-none");
      } else {
        //   return false;
        $(".put-price-back-block")
          .removeClass("d-none")
          .text("$" + financePerMonth);
        $(".per-month-text").text(" / mo. for 24 months");
        console.log("else part");
        accordionLastChild.removeClass("d-none");
      }
  
      if ($(".form-control").val() == "") {
        $(".put-price-back-block").addClass("d-none");
        $(".per-month-text").html(
          "Minimum Downpayment: $" +
            minDown +
            "<br/>" +
            "Maximum Downpayment: $" +
            maxDown
        );
      }
  
      let downTax = parseFloat(downpayment) * 0.13;
      // if (!$(".put-price-back-block").hasClass("d-none")) {
      //   $(".put-price-back-block").text("$" + financePerMonth);
      //   $(".per-month-text").text(" / mo. for 24 months");
      // }
  
      // Display - DownPayment summary
      $(".tax-summary-tax").text("$" + downTax.toFixed(2) + " Now");
      $(".total-summary-tax").text(
        "$" + (parseFloat(downpayment) + downTax).toFixed(2) + " Now"
      );
  
      // financePriceCalculations(minDown, maxDown);
    }
  
    function clear() {
      $(".tax-summary-tax").text("");
      $(".tax-summary-month").text("Select Your Plan");
      $(".total-summary-tax").text("");
      $(".total-summary-month").text("Select Your Plan");
    }
  
    function financeHeaderDetails(downpayment, financePerMonth) {
      $(".selected-payment-option").text("Finance over 24 months");
      $(".paid-down-payment").text("$" + downpayment + " today");
      $(".monthly-payment").text(
        "$" + financePerMonth + " per month on your TCC TAB"
      );
    }
  
    // 29 - change || Final Not working functionalities
    function finalNotWorkingRamBlockClickCalculatioin(devicePrice) {
      let down = $(".form-control").val();
      console.log("hello", devicePrice);
      console.log("world", down);
    }
  
    //   <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
  
    //   Print Summary
    $("#print-summary").on("click", function () {
      window.print();
    });
  
    // Lets get started Overlay
    $("#started-button").on("click", function () {
      console.log("lets");
      if (!$("#lets-get-started").hasClass("active")) {
        $("#lets-get-started").addClass("active");
        $(".overlay-device").toggleClass("overlay-active");
        $("body").css("overflow-y", "hidden");
      }
    });
  
    // Close button
    $("#lets-get-started .close-started-overlay i").on("click", function () {
      $("#lets-get-started").removeClass("active");
      $(".overlay-device").removeClass("overlay-active");
      $("body").css("overflow-y", "unset");
    });
  
    // Close model when Clicked on overlay
    $(".overlay-device").on("click", function () {
      $("#lets-get-started").removeClass("active");
      $(".overlay-device").removeClass("overlay-active");
      $("body").css("overflow-y", "unset");
    });
  
    // Social Hub - add drop shadow class
    $(".juicer-feed")
      .find(".feed-item")
      .each(function () {
        $(this).addClass("drop-shadow");
      });
  
    //   Select Color and Change Image Accordingly
    var color_id;
    $(".outline-green").each(function () {
      $(this).on("click", function () {
        color_id = $(this).attr("data-colorid");
        $(this).addClass("active-outline");
        $(this).siblings().removeClass("active-outline");
  
        $(".mobile-image-color").each(function () {
          $(".mobile-image-color").addClass("d-none");
          $("#" + color_id).removeClass("d-none");
        });
  
        // Dynamic Color Name Text Change
        $color_name = $(this).children("p")[0].innerHTML;
        $(".change-color").text($color_name);
        $(".device-color").text($color_name);
      });
    });
  
    $("#open-next-accordion").on("click", function () {
      console.log("clicked");
      // Close same accordion body and show its Header
      $(this).parents()[5].classList.remove("show");
      $(this).parents()[6].childNodes[1].childNodes[1].ariaExpanded = "false";
  
      // Open Next Element
      // console.log($(this).parents()[6]);
      // console.log($(this).parents()[6].nextElementSibling);
  
      if ($(this).parents()) {
        console.log("clicked next");
        $(
          this
        ).parents()[6].nextElementSibling.childNodes[3].childNodes[1].ariaExpanded =
          "true";
        // $(this).parents()[7].nextElementSibling.classList.add("show");
        console.log(
          $(this)
            .parents()[6]
            .nextElementSibling.childNodes[7].classList.add("show")
        );
      }
    });
  
    // Rest of the accordion continue button
    $(".rest-two-accordion").each(function () {
      $(this).on("click", function () {
        // Close open Tab first
        $(this).parent().parent().removeClass("show");
        $(this).parent().parent().prev().children()[0].ariaExpanded = "false";
  
        // Open Next Accordion
        var accordion_item = $(this).parent().parent().parent();
  
        accordion_item.next().children()[0].childNodes[1].ariaExpanded = "true";
        console.log(accordion_item.next().children()[1].classList.add("show"));
      });
    });
  
    //   Modal Open/Close
    $("#device-information .description-modal").on("click", function () {
      if (!$("#device-information .modal-container").hasClass("active")) {
        $("#device-information .modal-container").toggleClass("active");
        $(".overlay-device").toggleClass("overlay-active");
        $("body").css("overflow-y", "hidden");
      }
    });
  
    // Close button
    $(".modal-container .modal-data i").on("click", function () {
      $("#device-information .modal-container").removeClass("active");
      $(".overlay-device").removeClass("overlay-active");
      $("body").css("overflow-y", "unset");
    });
  
    // Close model when Clicked on overlay
    $(".overlay-device").on("click", function () {
      $("#device-information .modal-container").removeClass("active");
      $(".overlay-device").removeClass("overlay-active");
      $("body").css("overflow-y", "unset");
    });
  });
  